/* Scroll-driven progress rail - the source's data-lv-fill contract.

   The container carries data-lv-fill="<custom property>" and every row inside
   it data-lv-fill-item. The property is written as how far the rail has
   filled, 0 to 1, and a row takes .is-lit once its dot has passed the same
   line the fill is measured against.

   The line is 62% down the viewport. That is measured, not guessed: on the
   source at a 768px viewport the fill was still 0 while the rail's top sat at
   y=487 and reached 0.68 by y=128, and every sample in between fitted
   (0.62 * innerHeight - top) / height to within half a percent.

   DOT is how far into its row a dot sits - 24px here, 20px on phones. The
   source's own lighting threshold tolerates anything from 5px to 98px (step 2
   was dark at 471px from the line and lit at 378px), so one value covers both
   layouts.

   The first row stays lit throughout, as it does on the source, where the
   server-rendered markup ships .is-lit on it and scrolling away never clears
   it. */
window.lvFillInit = function (id) {
  var root = document.getElementById(id);
  /* not dataset.lvFill - that is the contract attribute above, already set on
     every root, so reading it here would make the guard fire on the first call */
  if (!root || root.dataset.lvFillOn) return;
  root.dataset.lvFillOn = '1';

  var DOT = 24;
  var prop = root.getAttribute('data-lv-fill') || '--lv-fill';
  var items = [].slice.call(root.querySelectorAll('[data-lv-fill-item]'));

  function update() {
    var b = root.getBoundingClientRect();
    var line = window.innerHeight * 0.62;
    var f = (line - b.top) / (b.height || 1);
    root.style.setProperty(prop, Math.max(0, Math.min(1, f)));
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle(
        'is-lit', i === 0 || items[i].getBoundingClientRect().top + DOT <= line);
    }
  }

  /* A background tab suspends the rendering pipeline: requestAnimationFrame
     never fires and no scroll event is dispatched at all. Update straight away
     in that case, and again the moment the tab is looked at, or the rail would
     be found sitting at zero. */
  var ticking = false;
  function onScroll() {
    if (document.hidden) { update(); return; }
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update);
  document.addEventListener('visibilitychange', update);
  update();
};
